import { render, staticRenderFns } from "./sortGoodsDetail.vue?vue&type=template&id=7e28cfbf&"
import script from "./sortGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./sortGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./sortGoodsDetail.vue?vue&type=style&index=0&id=7e28cfbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports